export const appHead = {"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.png"},{"rel":"manifest","href":"/manifest.webmanifest"},{"rel":"preconnect","href":"https://lvj1vt15bh.execute-api.eu-north-1.amazonaws.com","crossorigin":"anonymous"}],"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5"},{"charset":"utf-8"},{"property":"og:app_id","content":"1470413516498692"},{"property":"fb:app_id","content":"1470413516498692"},{"property":"og:type","content":"website"},{"name":"theme-color","content":"#004b9c"},{"name":"twitter:card","content":"summary_large_image"},{"property":"og:image:width","content":1200},{"property":"og:image:height","content":630}],"style":[],"script":[{"tagPosition":"bodyClose","innerHTML":"(function(){function def(o,k,v){if(!o[k]){Object.defineProperty(o,k,{value:v,configurable:true,writable:true})}}def(Object,\"hasOwn\",function(o,p){if(o==null){throw new TypeError(\"Cannot convert undefined or null to object\")}return Object.prototype.hasOwnProperty.call(Object(o),p)});function at(n){n=Math.trunc(n)||0;if(n<0){n+=this.length}if(n<0||n>=this.length){return undefined}return this[n]}def(Array.prototype,\"at\",at);def(String.prototype,\"at\",at);def(Array.prototype,\"findLast\",function(cb,t){for(var i=this.length-1;i>=0;i--){if(cb.call(t,this[i],i,this)){return this[i]}}});def(Array.prototype,\"findLastIndex\",function(cb,t){for(var i=this.length-1;i>=0;i--){if(cb.call(t,this[i],i,this)){return i}}return -1});})();"},{"tagPosition":"bodyClose","innerHTML":"window.uetq=window.uetq||[];window.dataLayer=window.dataLayer||[];(function(){function pushDataLayer(){window.dataLayer.push(arguments);window.uetq.push(...arguments);}pushDataLayer('consent','default',{\"ad_storage\":\"denied\",\"ad_user_data\":\"denied\",\"ad_personalization\":\"denied\",\"analytics_storage\":\"denied\"});})()"}],"noscript":[{"tagPosition":"bodyClose","innerHTML":"<iframe src=\"https://t.rolfstours.com/ns.html?id=GTM-5LS333XD\" height=\"0\" width=\"0\" title=\"Google Tag Manager\" style=\"display:none;visibility:hidden\"></iframe>"},{"tagPosition":"bodyClose","innerHTML":"<img height=\"1\" width=\"1\" alt=\"\" style=\"display:none\" src=\"https://www.facebook.com/tr?id=789125856832178&ev=PageView&noscript=1\"/>"}],"charset":"utf-8","viewport":"width=device-width, initial-scale=1, maximum-scale=5","htmlAttrs":{"lang":"en"},"bodyAttrs":{"class":"identity--rolfs"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const runtimeCompiler = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"prefetchOn":{"interaction":true,"visibility":false},"componentName":"NuxtLink","prefetch":true}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true